var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "catalog-spoiler",
        {
          "catalog-spoiler--open": _vm.isOpen,
          "catalog-spoiler--no-border": _vm.noBorder
        }
      ]
    },
    [
      !_vm.noHead
        ? _c(
            "div",
            { staticClass: "catalog-spoiler__head" },
            [
              _vm._t("head"),
              _c("div", {
                staticClass: "catalog-spoiler__head-action",
                on: {
                  click: function($event) {
                    return _vm.toggle(0)
                  }
                }
              }),
              _c(
                "svg",
                {
                  staticClass: "catalog-spoiler__head-icon",
                  attrs: { width: "10", height: "6", viewBox: "0 0 10 6" }
                },
                [
                  _c("path", {
                    attrs: { d: "M5 5.9l-5-5L.7.2 5 4.4 9.3.2l.7.7z" }
                  })
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "body",
          class: [
            "catalog-spoiler__body",
            { "catalog-spoiler__body--has-cut": _vm.hasCut }
          ],
          style: _vm.styles
        },
        [
          _c(
            "div",
            { ref: "inner", staticClass: "catalog-spoiler__body-inner" },
            [_vm._t("body")],
            2
          )
        ]
      ),
      _vm.hasCut
        ? _c(
            "div",
            {
              staticClass: "catalog-spoiler__cut-btn",
              on: { click: _vm.toggle }
            },
            [
              _vm.isOpen
                ? [_vm._v(_vm._s(_vm.cutTitle))]
                : [
                    _vm._v(
                      _vm._s(_vm.uncutTitle) +
                        " " +
                        _vm._s(_vm.itemsCount - _vm.visibleCount)
                    )
                  ]
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79e54df8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e54df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CatalogSpoiler.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-79e54df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CatalogSpoiler.vue
// module chunks = 0